export function NeedToStartNewLine(event: KeyboardEvent): boolean {
  return event.key === 'Enter' && (event.ctrlKey || event.metaKey || event.shiftKey);
}

export function GetContentWithNewLine(event: KeyboardEvent, content: string): string {
  // Insert newline at cursor position
  const textarea = event.target as HTMLTextAreaElement;
  const start = textarea.selectionStart;
  const end = textarea.selectionEnd;

  content = content.slice(0, start) + '\n' + content.slice(end);

  // Prevent default behavior
  event.preventDefault();

  // Set cursor position after newline
  setTimeout(() => {
    textarea.selectionStart = start + 1;
    textarea.selectionEnd = start + 1;
  }, 0);
  return content;
}

export function IsOnlyEmoji(content: string, maxNumOfEmojis = 3): boolean {
  return (
    [...Array.from(content)].length <= maxNumOfEmojis &&
    content.length / [...Array.from(content)].length === 2 &&
    /^[\p{Emoji}]+$/u.test(content)
  );
}
